/* eslint-disable camelcase */
/**
 * @author mcouetlannes
 * @date december 2022
 * @version
 * - 202221212: MCL : https://rndwww.nce.amadeus.net/agile/browse/EAC-2229
 * - 20240213: GP : https://rndwww.nce.amadeus.net/agile/browse/EAC-2942
 */

import {
  Inject,
  Injectable,
} from '@angular/core';
import {
  OrderModel,
  OrderStore,
  selectCurrentOrder,
} from '@des/store/order';
import {
  select,
  Store,
} from '@ngrx/store';
import {
  RequestParametersService,
} from '@o3r/dynamic-content';
import {
  DataLakeStore,
} from '@refx/analytics-core';
import {
  AppBootstrapConfig,
  BOOTSTRAP_CONFIGURATION_TOKEN,
  BOT_PROTECTION_FACTORY,
  BotProtectionFactory,
  getOrderMainLastName,
} from '@refx/shared-common';
import {
  filter,
  from,
  Observable,
  of,
  switchMap,
  take,
} from 'rxjs';
import {
  DeepLinkApiResponse,
} from '../contracts';
import {
  BlueApiClient,
} from './client';

@Injectable({
  providedIn: 'root'
})
export class DeepLinkService {

  private readonly apiClient: BlueApiClient;

  constructor(
    @Inject(BOOTSTRAP_CONFIGURATION_TOKEN) bootstrapConfig: AppBootstrapConfig,
    @Inject(BOT_PROTECTION_FACTORY) public botProtectionFactory: BotProtectionFactory,
    private readonly store: Store<OrderStore & DataLakeStore>,
    private readonly requestParametersService: RequestParametersService
  ) {
    this.apiClient = new BlueApiClient(bootstrapConfig, botProtectionFactory);
  }

  public getDeepLink(flavor: string | undefined, airlineCode: string): Observable<DeepLinkApiResponse | null> {
    const language = this.requestParametersService.getParameter('language');
    const country = this.requestParametersService.getParameter('market') ||
            this.requestParametersService.getParameter('country');

    return this.store.pipe(
      select(selectCurrentOrder),
      filter((currentOrder): currentOrder is OrderModel => !!currentOrder),
      take(1),
      switchMap(currentOrder => {
        const lastName = getOrderMainLastName(currentOrder);

        if (lastName && language && country) {

          const body = {
            interaction_method: 'online',
            distribution_type: 'direct',
            target_segment: 'B2C',
            interaction_channel_type: 'web',
            touchpoint_id: 'blueweb',
            target: flavor === 'refund' ? 'refund_deeplink_external' : 'trip_deeplink_external',
            language: language,
            country: country,
            brand: airlineCode,
            target_data: {
              bookingCode: currentOrder.id,
              lastName
            },
            ttl: 1800000,
            max_invocations: 3
          };
          return from(this.apiClient.call(JSON.stringify(body)));
        }
        return of(null);
      })
    );
  }
}
